import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { UpdatePhysicalSocketModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/inputs/charge-point/update-physical-socket.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useUpdateChargePointChannelPhysicalSocketContext } from '../../charge-point.context';
import { ChargePointChannelPhysicalSocketUpdateFormStep1Controller } from '../charge-point-channel-physical-socket-update-form-step-1/charge-point-channel-physical-socket-update-form-step-1.controller';

export interface ChargePointChannelPhysicalSocketUpdateFormControllerProps {
  onError: SubmitErrorHandler<
    Pick<
      UpdatePhysicalSocketModel,
      'chargePointId' | 'channelId' | 'physicalSocketId' | 'physicalSocket'
    >
  >;
  onSubmit: SubmitHandlerWithDirtyFields<
    Pick<
      UpdatePhysicalSocketModel,
      'chargePointId' | 'channelId' | 'physicalSocketId' | 'physicalSocket'
    >
  >;
  onCancel: () => void;
  state: MultiStepFormState;
}

export const ChargePointChannelPhysicalSocketUpdateFormController = (
  props: ChargePointChannelPhysicalSocketUpdateFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel, state } = props;
  const data = useUpdateChargePointChannelPhysicalSocketContext();

  return (
    <MultiStepFormProvider<
      Pick<
        UpdatePhysicalSocketModel,
        'chargePointId' | 'channelId' | 'physicalSocketId' | 'physicalSocket'
      >
    >
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      state={state}
      items={[
        {
          fields: [
            'physicalSocket.standard',
            'physicalSocket.format',
            'physicalSocket.amperage',
            'physicalSocket.voltage',
            'physicalSocket.powerType',
          ],
          component: (
            <ChargePointChannelPhysicalSocketUpdateFormStep1Controller />
          ),
        },
      ]}
    />
  );
};
